import {defineSlotRecipe} from '@chakra-ui/react3'

export const footerNewsletterRecipe = defineSlotRecipe({
    slots: [
        'root',
        'content',
        'signUp',
        'textGroup',
        'confirmation',
        'heading',
        'copy',
        'copyGroup',
        'artwork',
        'artworkImage'
    ],
    base: {
        root: {
            position: 'relative',
            width: 'full',
            overflow: 'hidden',
            borderTopRadius: {base: '2xl', s: '3xl'},
            paddingBlockStart: {base: 'spacing-40', s: 'spacing-80'},
            paddingInline: {base: 'spacing-24', s: 'spacing-90'}
        },
        content: {
            position: 'relative',
            width: 'full',
            maxWidth: 'container-page-max-width',
            marginInline: 'auto'
        },
        signUp: {
            position: 'relative',
            zIndex: '1',
            display: 'grid',
            gridTemplateColumns: {base: '1fr', s: 'minmax(0, 1fr) minmax(0, 1fr)'},
            gap: {base: 'spacing-24', s: 'spacing-80'},
            minHeight: {base: 0, s: '16.625rem'},
            alignItems: 'start'
        },
        textGroup: {
            position: 'relative',
            zIndex: '1',
            display: 'flex',
            flexDirection: 'column',
            width: {s: '28.125rem'},
            gap: 'spacing-16',
            textAlign: 'start'
        },
        confirmation: {
            display: 'grid',
            gridTemplateColumns: {base: '1fr', s: 'minmax(0, 1fr) minmax(0, 1fr)'},
            gap: {base: 'spacing-32', s: 'spacing-80'},
            minHeight: {base: 0, s: '15rem'},
            alignItems: 'center',
            _focus: {
                outline: 'none'
            }
        },
        heading: {
            color: 'text.primary',
            textStyle: 'display.small'
        },
        copy: {
            color: 'text.secondary',
            textStyle: 'body.medium'
        },
        copyGroup: {
            display: 'flex',
            flexDirection: 'column',
            width: {s: '28.125rem'},
            gap: 'spacing-24'
        },
        artwork: {
            // Mobile artwork is inset 6px on each side, making it 12px narrower than its container.
            '--newsletter-artwork-inline-inset': {base: 'spacing-6', s: '0px'},
            position: {base: 'relative', s: 'absolute'},
            width: {
                base: 'calc(100% - var(--newsletter-artwork-inline-inset) - var(--newsletter-artwork-inline-inset))',
                s: '22.875rem'
            },
            maxHeight: {base: '11.875rem', s: 'none'},
            marginBlockStart: {base: 'spacing-32', s: '0'},
            marginInline: 'var(--newsletter-artwork-inline-inset)',
            zIndex: '0',
            insetInlineStart: {s: '0'},
            bottom: {s: 'calc(-1 * var(--leap-spacing-spacing-80))'},
            pointerEvents: 'none'
        },
        artworkImage: {
            display: 'block',
            width: 'full',
            height: 'auto',
            color: 'background.newsletter-artwork'
        }
    },
    variants: {
        view: {
            signUp: {
                root: {
                    backgroundColor: 'background.section.default',
                    paddingBlockEnd: {s: 'spacing-80'}
                }
            },
            confirmation: {
                root: {
                    backgroundColor: 'background.actions.primary',
                    paddingBlockEnd: {base: 'spacing-40', s: 'spacing-80'},
                    color: 'text.on-media.primary',
                    _after: {
                        content: '""',
                        position: 'absolute',
                        zIndex: 1,
                        inset: 0,
                        backgroundColor: 'background.section.default',
                        pointerEvents: 'none',
                        animationStyle: 'newsletter-wipe'
                    }
                },
                heading: {color: 'text.on-media.primary'},
                copy: {color: 'text.on-media.primary'}
            }
        }
    },
    defaultVariants: {
        view: 'signUp'
    }
})
